import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  shipmentTracking: '',
};

const shipmentTrackingSlice = createSlice({
  name: 'shipmentTracking',
  initialState,

  reducers: {
    setShipmentTracking(state, action) {
      state.shipmentTracking = action.payload;
    },
    removeShipmentTracking(state) {
      state.shipmentTracking = initialState.shipmentTracking;
    },
  },
});

export const { setShipmentTracking, removeShipmentTracking } =
  shipmentTrackingSlice.actions;

export const shipmentTrackingNumber = (state) =>
  state.shipmentTracking.shipmentTracking;

export const shipmentTrackingSliceReducer = shipmentTrackingSlice.reducer;
export const shipmentTrackingSliceReducerName = shipmentTrackingSlice.name;

export default shipmentTrackingSlice.reducer;
